import {postRequest} from "./helper"
export const NotificationListApi = (data) => postRequest('notification_list ',data);
export const unreadNotificationListApi = (data) => postRequest('unread_notification',data);
export const changeNotificationStatusApi = (data) => postRequest('change_status',data);





// WEBPACK FOOTER //
// ./src/api/Notifications.js